import { createFileRoute } from '@tanstack/react-router';
import { PERMISSION_PERIOD_LOCK } from '../../Services/PermissionsService';
import { requirePermission } from '../../router/RouteGuardsService';
import PeriodLockSetting from '../../components/PeriodLock/PeriodLockSetting';

export const Route = createFileRoute('/_authenticated/period-lock/definition/')({
  beforeLoad: async ({ context }) => {
    await requirePermission(PERMISSION_PERIOD_LOCK, ['read'], '/unauthorized', context);

    return {
      ...context,
      documentTitle: {
        main: 'tab.period-lock-definition',
        suffix: 'menu.periodLock',
      },
    };
  },
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  component: PeriodLockDefinitionRoute,
});

function PeriodLockDefinitionRoute() {
  return <PeriodLockSetting />;
}
